// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20nYz","content":"styles_content__1D1rc"};